export default __webpack_public_path__ + "static/media/MaleAvt.8bb3b1b3.png";